import { ErrorBoundary } from '../c-mp/comp/ErrorBoundary'
import { Icon } from '../c-mp/comp/Icon'
import { $when, Show } from '../c-mp/comp/Show'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { json } from '../c-mp/fun/json'
import { usePopover } from '../c-mp/fun/usePopover'
import { mutateState, useState } from '../c-mp/fun/useState'
import { andrisEmail } from '../fun/andrisEmail'
import { onLinkClickFocusSearchInput } from '../fun/onLinkClickFocusSearchInput'
import { useRouting } from '../fun/useRouting'
import { ICON_HOME } from '../icon/ICON_HOME'
import { ICON_MENU } from '../icon/ICON_MENU'
import { ICON_SEARCH } from '../icon/ICON_SEARCH'
import { appState } from '../model/appState'
import { _ } from '../model/ccc'
import { Page } from '../model/Page'
import { FooterComp } from './FooterComp'
import { LogInComp } from './LogInComp'
import { MenuComp } from './MenuComp'
import { PageAverageAgeComp } from './PageAverageAgeComp'
import { PageBirthdaysComp } from './PageBirthdaysComp'
import { PageCloudsComp } from './PageCloudsComp'
import { PageEmailsComp } from './PageEmailsComp'
import { PageHomeComp } from './PageHomeComp'
import { PageInvalidComp } from './PageInvalidComp'
import { PageNotFoundComp } from './PageNotFoundComp'
import { PageParentlessComp } from './PageParentlessComp'
import { PagePersonComp } from './PagePersonComp'
import { PagePersonContemporariesComp } from './PagePersonContemporariesComp'
import { PagePersonTreeComp } from './PagePersonTreeComp'
import { PageQuizComp } from './PageQuizComp'
import { PageRelativesAliveComp } from './PageRelativesAliveComp'
import { PageSearchComp } from './PageSearchComp'
import { PageWeddingAnniversariesComp } from './PageWeddingAnniversariesComp'

export const AppComp = defineComponent<{}>('AppComp', (props, $) => {
	useRouting()

	const state = useState('state', {
		loggingOut: false,
		menuRef: null as HTMLDivElement | null,
		menuButtonRef: null as HTMLButtonElement | null,
	})

	const menuPopover = usePopover({
		getMenuElem: () => state.menuRef,
		getButtonElem: () => state.menuButtonRef,
	})

	async function logOut() {
		try {
			mutateState('AppComp', 'set logging out [t8mdd3]', () => {
				state.loggingOut = true
			})
			const response = await fetch('/logout', {
				method: 'post',
				credentials: 'include',
			})
			if (response.ok) {
				mutateState('AppComp', 'unset data, unset logging out [t8md94]', () => {
					appState.data = undefined
					state.loggingOut = false
				})
			} else {
				throw new Error(
					json`[t8mda2] ${response.status} ${response.statusText}`,
				)
			}
		} catch (e) {
			console.error(e)
			mutateState('AppComp', 'unset logging out [t8mde8]', () => {
				state.loggingOut = false
			})
		}
	}

	return (
		<div class='ccc_app' inert={state.loggingOut}>
			<ErrorBoundary
				debugName='Oldalak'
				try={() => (
					<>
						<Show
							debugName='Van adat'
							else={LogInComp}
							it={[
								$when(
									() => appState.data,
									() => (
										<>
											<header>
												<Show
													it={$when(
														() => appState.page !== Page.Home,
														() => (
															<div class='ccc_header_start'>
																<a class={_.ccc_button} href='/'>
																	<Icon svg={ICON_HOME} /> Kezdőoldal
																</a>
															</div>
														),
													)}
												/>
												<div class='ccc_header_end'>
													<a
														class={_.ccc_button}
														href='/search'
														onclick={onLinkClickFocusSearchInput}
													>
														<Icon svg={ICON_SEARCH} /> Kereső
													</a>
													<button
														ref={(it) =>
															mutateState(
																$.debugName,
																'store menu button ref [tbc5o9]',
																() => (state.menuButtonRef = it),
															)
														}
														class={() => [
															_.ccc_button,
															menuPopover.getIsOpen() && _.ccc__selected,
														]}
														onclick={menuPopover.toggle}
													>
														<Icon svg={ICON_MENU} /> Menü
													</button>
													<div
														ref={(it) =>
															mutateState(
																$.debugName,
																'store menu ref [tbc5i5]',
																() => (state.menuRef = it),
															)
														}
														class={_.ccc_menu}
														onclick={menuPopover.close}
													>
														<MenuComp logOut={logOut} />
													</div>
												</div>
											</header>
											<Show
												debugName='Oldal'
												it={[
													$when(
														() => appState.page === Page.NotFound,
														PageNotFoundComp,
													),
													$when(
														() => appState.page === Page.Home,
														PageHomeComp,
													),
													$when(
														() => appState.page === Page.Person,
														PagePersonComp,
													),
													$when(
														() => appState.page === Page.PersonTree,
														PagePersonTreeComp,
													),
													$when(
														() => appState.page === Page.PersonContemporaries,
														PagePersonContemporariesComp,
													),
													$when(
														() => appState.page === Page.Search,
														PageSearchComp,
													),
													$when(
														() => appState.page === Page.RelativesAlive,
														PageRelativesAliveComp,
													),
													$when(
														() => appState.page === Page.Parentless,
														PageParentlessComp,
													),
													$when(
														() => appState.page === Page.Birthdays,
														PageBirthdaysComp,
													),
													$when(
														() => appState.page === Page.WeddingAnniversaries,
														PageWeddingAnniversariesComp,
													),
													$when(
														() => appState.page === Page.Emails,
														PageEmailsComp,
													),
													$when(
														() => appState.page === Page.AverageAge,
														PageAverageAgeComp,
													),
													$when(
														() => appState.page === Page.Clouds,
														PageCloudsComp,
													),
													$when(
														() => appState.page === Page.Quiz,
														PageQuizComp,
													),
												]}
												else={PageInvalidComp}
											/>
										</>
									),
								),
							]}
						/>
						<Show
							debugName='Élőláb látszik'
							it={$when(() => appState.page !== Page.PersonTree, FooterComp)}
						/>
					</>
				)}
				catch={({ error, stack }) => (
					<div class={_.ccc_page}>
						<h1>Hiba történt</h1>
						<p>Az alábbi információt kaptuk:</p>
						<p>
							<pre>
								<Slot get={() => error} />
							</pre>
						</p>
						<p>
							<a
								href={() =>
									andrisEmail(
										'Hiba a Parditka családfában',
										`Ezt a hibát találtam:\n\nURL: ${location.href}\n\nBöngésző: ${navigator.userAgent}\n\nHiba: ${error}\n${stack}`,
									)
								}
							>
								Küldd el Andrisnak
							</a>
						</p>
					</div>
				)}
			/>
		</div>
	)
})
